document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.cb-faq-simple');

  sections.forEach(function (section) {
    var list = section.querySelector('[data-faq-list]');
    if (!list) return;

    function closeAll() {
      var items = list.querySelectorAll('.cb-faq-simple__item');
      items.forEach(function (item) {
        item.classList.remove('is-open');
        var button = item.querySelector('.cb-faq-simple__question');
        var answer = item.querySelector('.cb-faq-simple__answer-wrap');
        if (button) button.setAttribute('aria-expanded', 'false');
        if (answer) answer.hidden = true;
      });
    }

    function openItem(item) {
      item.classList.add('is-open');
      var button = item.querySelector('.cb-faq-simple__question');
      var answer = item.querySelector('.cb-faq-simple__answer-wrap');
      if (button) button.setAttribute('aria-expanded', 'true');
      if (answer) answer.hidden = false;
    }

    var questions = list.querySelectorAll('.cb-faq-simple__question');

    questions.forEach(function (questionButton) {
      questionButton.addEventListener('click', function () {
        var item = questionButton.closest('.cb-faq-simple__item');
        var isOpen = item.classList.contains('is-open');

        closeAll();

        if (!isOpen) {
          openItem(item);
        }
      });
    });
  });
});